export class ErrorResponse {
  constructor(public message: string, public status: number) {}
}
